import React, { useMemo, useEffect, useState } from "react";
import { useNewsStore } from "../../../stores/use-news-store";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { useBlogs } from "../useBlogs";
import { useAtlassianLocale } from "@Shared/Hooks/useAtlassianLocale";
import NewsPreview from "../preview/NewsPreview";
import { PaginationTypes } from "@Shared/Pagination-Types";
import CustomEmptyState from "../../../components/empty-state/CustomEmptyState";
import { CUSTOM_EMPTY_STATE_KEY } from "../../../components/empty-state/custom-templates";

function ManualNews({ isEdit, mode }) {
  const [locale] = useAtlassianLocale();
  const isCosmosInstalled = useOpticsStore((state) => state.isCosmosInstalled);

  const { config, selectedTab } = useNewsStore((state) => ({
    config: state.data.config,
    selectedTab: state.getSelectedTab(),
  }));

  const { tabs, pagination, variant } = config || {};
  const isMagazine = variant === "magazine";
  const tab = tabs?.[selectedTab];

  const limit = isEdit ? 999 : Number(isMagazine ? 4 : tab?.limit || 4);
  const manuallyPicked = tab?.manuallyPicked || [];

  const blogQueries = useBlogs(manuallyPicked, isCosmosInstalled, locale);

  const blogResults = useMemo(
    () =>
      blogQueries
        .map((q) => q.data)
        .filter((q) => q && !q.isPlaceholder && !q.isNew),
    [blogQueries]
  );

  const [page, setPage] = useState(0);
  const isCarousel = pagination === PaginationTypes.CAROUSEL;
  const startIndex = isCarousel ? page * limit : 0;
  const endIndex = page * limit + limit;
  const paginatedBlogs = blogResults.slice(startIndex, endIndex);

  const queryPagination = {
    disabled: isEdit || pagination === PaginationTypes.NONE,
    hasNextPage: endIndex < blogResults.length,
    hasPrevPage: page > 0,
    onNext: () => {
      if (endIndex < blogResults.length) setPage((prev) => prev + 1);
    },
    onPrev: () => {
      if (page > 0) setPage((prev) => prev - 1);
    },
    page,
    setPage,
  };

  useEffect(() => setPage(0), [pagination]);

  if (!paginatedBlogs.length) {
    return <CustomEmptyState templateKey={CUSTOM_EMPTY_STATE_KEY.NEWS_SETUP} />;
  }

  const paginationData = { [isCarousel ? page : 0]: paginatedBlogs };

  return (
    <NewsPreview
      data={paginationData}
      queryPagination={queryPagination}
      mode={mode}
    />
  );
}

export default ManualNews;
